import { mapGetters } from 'vuex'

export const requestRedirectionWorkAreas = {
  computed: {
    ...mapGetters({
      getWorkAreas: 'getWorkAreas'
    })
  },
  methods: {
    redirectionWorkAreas: function (serviceObject) {
      const workAreas = []
      if (serviceObject && serviceObject.workAreas && serviceObject.workAreas.length) {
        serviceObject.workAreas.forEach(workArea => {
          workArea.availableRedirections.forEach(availableRedirection => {
            if (!workAreas.some(wA => wA.id === availableRedirection.id)) {
              workAreas.push(availableRedirection)
            }
          })
        })
        return workAreas
      } else {
        return this.getWorkAreas.map(workArea => {
          return {
            id: workArea.key,
            name: workArea.name
          }
        })
      }
    }
  }
}
